import React from 'react';
// import { StaticImage } from 'gatsby-plugin-image';
import Select from 'react-select';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import TabSidebarBlock from '../components/TabSidebarBlock';
import { WhiteBlock } from '../styles/WhiteBlock';

const fontFamily = [
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Inter', label: 'Inter' },
];
const fontWeight = [
  { value: '300', label: '300' },
  { value: '400', label: '400' },
  { value: '500', label: '500' },
  { value: '600', label: '600' },
  { value: '700', label: '700' },
  { value: '800', label: '800' },
];
const fontSize = [
  { value: '12px', label: '12px' },
  { value: '13px', label: '13px' },
  { value: '14px', label: '14px' },
  { value: '15px', label: '15px' },
  { value: '16px', label: '16px' },
];

const Typography = () => (
  <Layout>
    <SEO title="Typography" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          dashboard
        </a>

        <h1 className="db-heading">
          Dribbble Workspace{' '}
          <img
            src="/img/chevron-down.svg"
            alt="chevron"
            style={{ width: 23, opacity: 0.4 }}
          />
        </h1>

        <TabHeaderBlock />

        <div className="db-tab-content-block">
          <div className="flex-row">
            <div className="col sidebar-col">
              <TabSidebarBlock />
            </div>

            <div className="col right-block-col">
              <WhiteBlock>
                <h2 className="white-block-head">Typography</h2>

                <div className="white-block-body">
                  <table
                    className="table typography-table"
                    cellPadding="0"
                    cellSpacing="0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Font</th>
                        <th>Font Weight</th>
                        <th>Font Size</th>
                        <th>Colour Picker</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span style={{ fontSize: 23, fontWeight: 800 }}>
                            Heading 1
                          </span>
                        </td>

                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select"
                              options={fontFamily}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select font-weight-select"
                              options={fontWeight}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select font-size-select"
                              options={fontSize}
                            />
                          </div>
                        </td>
                        <td>
                          <span
                            className="single-color-circle"
                            style={{
                              backgroundColor: '#FBBF2E',
                              boxShadow: 'none',
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span style={{ fontSize: 20, fontWeight: 800 }}>
                            Heading 2
                          </span>
                        </td>

                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select"
                              options={fontFamily}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select font-weight-select"
                              options={fontWeight}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="choice-box">
                            <Select
                              className="custom-select font-size-select"
                              options={fontSize}
                            />
                          </div>
                        </td>
                        <td>
                          <span
                            className="single-color-circle"
                            style={{
                              backgroundColor: '#FF7968',
                              boxShadow: 'none',
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div
                    className="flex-row no-margin align-items-center"
                    style={{
                      borderBottom: '1px solid #eee',
                      paddingBottom: 30,
                    }}>
                    <div className="col col-8">
                      <p style={{ fontWeight: 600, fontSize: 16, margin: 0 }}>
                        Remove Styling while pasting
                      </p>
                    </div>
                    <div className="col col-4">
                      <div className="text-right">
                        <label className="switch">
                          <input type="checkbox" />
                          <span className="slider" />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="text-right" style={{ marginTop: 35 }}>
                    <button className="button" type="button">
                      Save details
                    </button>
                  </div>
                </div>
              </WhiteBlock>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default Typography;
